import React from 'react';

import {LogoButton} from './logo.styles'

const Logo = (props) => {
    return (
        <LogoButton color={props.theme}>
          Ahmed Atif
        </LogoButton>
    )
}

export default Logo
